import React from "react";
import "./App.css";
import ApplicationRoutes from "./config/ApplicationRoutes";

function App() {
  return <ApplicationRoutes />;
}

export default App;
